import game from '../config/game.json'

export interface EnvConfig {
  env: string
  platformOrigins: string[]
  analytics: { provider: string; key: string }
  errors: { provider: string; dsn: string }
}

// Injected at build time from config/env/<mode>.json (vite.config.ts). Only the active environment is bundled.
// Environment files are public (they ship with the build): never put secrets in them.
declare const __HITZ_ENV_CONFIG__: EnvConfig

export const ENV: EnvConfig = __HITZ_ENV_CONFIG__
export const GAME = game
export const IS_DEV = ENV.env === 'local'
